import React from 'react';
import PropTypes from 'prop-types';
import Container from './container';

const SELECT_CLASS_NAME = 'floating-label-text-input';

export const TextInput = props => {
    const onBlurUpdate = () => {
        setTimeout(() => {
            props.onBlur(props.value);
        }, 100);
    }
    return (
        <Container
            name={props.name}
            label={props.label}
            hasValue={props.value !== ''}
            highlight={props.highlight}
            disabled={props.disabled}
            loading={props.loading}
            hintText={props.hintText}
            errorText={props.errorText}
            invalid={props.invalid}
            additionalClassNames={[SELECT_CLASS_NAME].concat(props.additionalClassNames)}
        >
            <input
                className="floating-label-text-input__input"
                type="text"
                value={props.value}
                name={props.name}
                onChange={event => props.onChange(event.target.value, props.name)}
                disabled={props.disabled}
                placeholder={props.label}
                maxLength={props.maxLength}
                autoComplete={props.autoComplete}
                onBlur={onBlurUpdate}
            />
        </Container>
    );
}

TextInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    highlight: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    hintText: PropTypes.string,
    errorText: PropTypes.string,
    invalid: PropTypes.bool,
    additionalClassNames: PropTypes.array,
    maxLength: PropTypes.string,
    autoComplete: PropTypes.string,
};


TextInput.defaultProps = {
    additionalClassNames: [],
    maxLength: '524288', // html default for this attribute,
    autoComplete: 'on',
    onBlur: () => { },
};

export default TextInput;
